import getFileProviderItems from '../../actions/getFileProviderItems';
import searchFileProviderItems from '../../actions/search/searchFileProviderItems';
import FilePickerPanelViewState from '../../store/schema/FilePickerPanelViewState';
import GetFileProviderItemsResponse from '../../types/GetFileProviderItemsResponse';

export default async function getOrSearchFileProviderItems(
    viewState: FilePickerPanelViewState,
    isRefreshing: boolean = false
): Promise<GetFileProviderItemsResponse> {
    const {
        selectedFileProvider,
        selectedProviderScope,
        filePickerViewState: {
            selectedFolder: folder,
            fileProviderItems,
            pagingMetadata,
            columnSorting,
            searchViewState: { searchQuery, isInSearchMode },
            filterOptionsState,
        },
    } = viewState;

    const fileProviderId = selectedFileProvider.model.Id;
    const fileProviderEndpointUrl = selectedFileProvider.model.EndPointUrl;
    const fileProviderType = selectedFileProvider.type;

    const { key = null, location = null } = folder || {};

    if (!isInSearchMode) {
        return await getFileProviderItems(
            fileProviderType,
            fileProviderId,
            isRefreshing ? 0 : fileProviderItems.length,
            filterOptionsState.selectedFilterOption,
            selectedProviderScope,
            fileProviderEndpointUrl,
            key /* folderId */,
            location,
            pagingMetadata,
            columnSorting
        );
    } else {
        return await searchFileProviderItems(
            fileProviderType,
            fileProviderId,
            searchQuery,
            fileProviderItems.length,
            key /* folderId */,
            location,
            pagingMetadata,
            columnSorting
        );
    }
}
